module.exports = __webpack_public_path__ + "img/five_zh.81e71e32.jpg";